import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        departments: '=',
        roles: '=',
        levels: '=',
        course: '=',
        drlId: '=',
        employeeDrl: '=',
        courseDrlUsers: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'courses.Edit target' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div ng-if="!vm.employeeDrl && vm.hasConnectedApg" class="alert alert-warn" ng-bind-html="vm.hasConnectedApgTargetTranslation"></div>
            <form-wrapper form="vm.form">
                <form-row error="vm.form.errors.courseTargets">
                    <span ng-bind-html="vm.form.errors.courseTargets"></span>
                </form-row>
                <div class="form">
                    <form-row ng-if="!vm.employeeDrl" error="vm.form.errors.departmentId">
                        <label class="label">{{ 'courses.Department' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.department" theme="selectize" title="{{ 'user.Choose department' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a department in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="department in vm.departments | filter: $select.search">
                                    <span ng-bind-html="department.name | highlight: $select.search" class="{{department.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <form-row ng-if="!vm.employeeDrl" error="vm.form.errors.roleId">
                        <label class="label">{{ 'courses.Role' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.role" theme="selectize" title="{{ 'user.Choose role' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a role in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="role in vm.roles | filter: $select.search">
                                    <span ng-bind-html="role.name | highlight: $select.search" class="{{role.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <form-row ng-if="!vm.employeeDrl" error="vm.form.errors.levelId">
                        <label class="label">{{ 'courses.Level' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.level" theme="selectize" title="{{ 'user.Choose level' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a level in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="level in vm.levels | filter: $select.search">
                                    <span ng-bind-html="level.name | highlight: $select.search" class="{{level.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <div ng-if="vm.employeeDrl" class="row">
                        <div class="row">
                            <span class="label">{{ 'courses.Employee' | translate }}</span>
                            <div class="items">
                                <span class="text">{{ vm.employeeDrl.employee.displayName }}</span>
                            </div>
                        </div>
                    </div>
                    <form-row ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()" error="vm.form.errors.type">
                        <label class="label">{{ 'courses.Training need' | translate }}</label>
                        <form-row-error></form-row-error>
                        <div class="items">
                            <ul class="checkboxes">
                                <li>
                                    <label ng-if="vm.employeeDrl" ng-repeat="(value, label) in vm.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.LABELS">
                                        <input ng-model="vm.form.model.type" value="{{ value }}" type="radio" name="r01"> {{ label }}
                                    </label>
                                    <label ng-if="!vm.employeeDrl" ng-repeat="(value, label) in vm.COURSE_TARGET_NEED_TYPE_ENUM.LABELS">
                                        <input ng-model="vm.form.model.type" value="{{ value }}" type="radio" name="r01"> {{ label }}
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </form-row>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.save($event)">{{ 'general.Save' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $q, lodash, FormFactory, TokenService, CourseService, ModalService, UserResource, CourseResource,
                 COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM, COURSE_TARGET_NEED_TYPE_ENUM, AUTOMATED_PLANNING_GROUP_STATUS_ENUM,
                 AUTOMATED_PLANNING_GROUP_TYPE_ENUM, AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM, toastr) {
        this.FormFactory = FormFactory;
        this.lodash = lodash;
        this.$translate = $translate;
        this.$q = $q;
        this.lodash = lodash;
        this.FormFactory = FormFactory;
        this.TokenService = TokenService;
        this.CourseService = CourseService;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM = COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
        this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_TYPE_ENUM;
        this.AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM;
        this.ModalService = ModalService;
        this.UserResource = UserResource;
        this.CourseResource = CourseResource;
        this.toastr = toastr;
    }

    $onInit () {
        this.departments = this.mapClassifier(this.departments, this.$translate.instant('course.All departments'));
        this.roles = this.mapClassifier(this.roles, this.$translate.instant('course.All roles'));
        this.levels = this.mapClassifier(this.levels, this.$translate.instant('course.All levels'));

        this.hasConnectedApgTargetTranslation = this.$translate.instant('courses.has_connected_apg_target');

        this.createForm();
        this.initDrl();

        this.detectConnectedApgTarget();
    }

    /**
     * Detect whether course is connected with automatic APG-s and has apg that is not cancelled where targets are used
     */
    detectConnectedApgTarget () {
        this.hasConnectedApg = false;

        if (!this.drlId && !this.employeeDrl) {
            return;
        }

        if (this.existingDrl && this.existingDrl.type !== this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.COMPULSORY) {
            return;
        }

        if (this.employeeDrl && this.employeeDrl.type !== this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.COMPULSORY) {
            return;
        }

        this.course.planningGroups.forEach((apg) => {
            if (apg.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.CANCELLED
                || apg.type !== this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC) {
                return; // go to next iteration
            }

            if (apg.targetType === this.AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM.KEYS.ALL_COURSE_TARGETS) {
                this.hasConnectedApg = true;
                return;
            }

            apg.planningGroupTargets.forEach((apgTarget) => {
                if (this.drlId && parseInt(apgTarget.courseTargetId, 10) === parseInt(this.drlId, 10)) {
                    this.hasConnectedApg = true;
                }

                if (this.employeeDrl && parseInt(apgTarget.courseTargetId, 10) === parseInt(this.employeeDrl.id, 10)) {
                    this.hasConnectedApg = true;
                }
            });
        });
    }

    mapClassifier (classifier, defaultName) {
        classifier = classifier.map((val) => ({ name: val.value, id: val.id }));
        classifier.unshift({
            name: defaultName,
            id: undefined,
            class: 'separated'
        });
        return classifier;
    }

    initDrl () {
        this.department = { id: undefined, name: this.$translate.instant('course.All departments') };
        this.role = { id: undefined, name: this.$translate.instant('course.All roles') };
        this.level = { id: undefined, name: this.$translate.instant('course.All levels') };

        // find correct object from array to display on form
        this.existingDrl = this.lodash.find(this.course.courseTargetsWithValue, { id: this.drlId });
        this.department = { id: this.existingDrl.departmentId, name: this.existingDrl.departmentName ? this.existingDrl.departmentName : this.$translate.instant('course.All departments') };
        this.role = { id: this.existingDrl.roleId, name: this.existingDrl.roleName ? this.existingDrl.roleName : this.$translate.instant('course.All roles') };
        this.level = { id: this.existingDrl.levelId, name: this.existingDrl.levelName ? this.existingDrl.levelName : this.$translate.instant('course.All levels') };
        this.form.model.type = this.existingDrl.type;
    }

    createForm () {
        this.CourseService.nestCompositeModels(this.course);
        this.form = this.FormFactory.create(this.course, model => model.$update({ id: model.id }));
    }

    confirm (message) {
        const deferred = this.$q.defer();
        const params = {
            drlCourseId: this.course.id,
            'updatedCourseDrl[id]': this.drlId,
            'updatedCourseDrl[departmentId]': this.department.id ? this.department.id : '',
            'updatedCourseDrl[roleId]': this.role.id ? this.role.id : '',
            'updatedCourseDrl[levelId]': this.level.id ? this.level.id : ''
        };

        this.UserResource.query(params).$promise
            .then(newCourseDrlUsers => {
                const usersToRemove = this.courseDrlUsers.filter(u => this.lodash.find(newCourseDrlUsers, { id: u.id }) === undefined);
                if (usersToRemove.length) {
                    this.ModalService.confirm(message)
                        .then(() => deferred.resolve())
                        .catch(() => deferred.reject())
                    ;
                }
                else {
                    deferred.resolve();
                }
            })
            .catch(() => deferred.reject());
        return deferred.promise;
    }

    beforeSave () {
        if (this.form.model.expirationMonths === null) {
            this.form.model.expirationMonths = 0;
        }

        this.form.model.courseTargets = this.course.courseTargetsWithValue;

        this.lodash.remove(this.form.model.courseTargets, { id: this.drlId });
        this.form.model.courseTargets.push({
            id: this.drlId,
            departmentId: this.department.id,
            roleId: this.role.id,
            levelId: this.level.id,
            type: this.form.model.type,
            employeeId: this.employeeDrl ? this.employeeDrl.employeeId : null
        });

        this.form.model.fields = this.course.courseFields.map((field) => (field.fieldId));
        this.form.model.courseSiteIds = this.course.sites.map(site => (site.id));
        this.form.model.courseTrainings = this.course.courseTrainings;
    }

    save (event) {
        event.currentTarget.classList.add('loading');
        event.currentTarget.disabled = true;
        new Promise(resolve => {
            this.beforeSave();
            if (!this.employeeDrl) {
                const message = this.$translate.instant('planningGroup.confirm_remove_some_users_after_drl_change');
                this.confirm(message).then(() => this.doSave());
            }
            else {
                if (this.hasConnectedApg && this.form.model.type !== this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.KEYS.COMPULSORY) {
                    const message = this.$translate.instant('planningGroup.confirm_exception_type_change_in_connection_with_apg');
                    this.ModalService.confirm(message, 'medium').then(() => this.saveEmployeeTarget());
                }
                else {
                    this.saveEmployeeTarget();
                }
            }
            return resolve;
        }).then(() => {
            event.currentTarget.classList.remove('loading');
            event.currentTarget.disabled = false;
        });
    }

    doSave () {
        this.form.save()
            .then(() => this.uibModalInstance.close())
            // in case of error remove the last added drl
            .catch((error) => {
                this.form.model.courseTargets.splice(-1, 1);
                this.error = this.lodash.get(error.data, '[0].message');
                this.toastr.error(this.error);
            });
    }

    saveEmployeeTarget () {
        this.CourseResource.setTargetExceptions(
            { id: this.course.id },
            {
                userIds: [this.employeeDrl.employeeId],
                type: this.form.model.type
            }
        ).$promise.then(() => {
            this.uibModalInstance.close();
        })
        .catch((error) => {
            this.error = this.lodash.get(error.data, '[0].message');
            this.toastr.error(this.error);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/drl/edit/index.js